import { render, staticRenderFns } from "./editOnlineDict.vue?vue&type=template&id=676eeb55&"
import script from "./editOnlineDict.vue?vue&type=script&lang=js&"
export * from "./editOnlineDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports